<template>
  <div>
    <PartnerHeader :img_header="header_image" header="แก้ไขข่าวสารใหม่" link_back="newsinformation"/>
    <MenuPartner/>
    <News_edit/>
  </div>
</template>

<script>
import PartnerHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import HeaderImage from "@/assets/news.png";
// import MenuPartner from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/MenuPartner";
import News_edit from "@/components/admin/manage_pos/news_store_setting/News_edit";
export default {
  name: "NewsEdit",
  components: {
    News_edit,
    // MenuPartner,
    PartnerHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
